import toast from 'react-hot-toast';
import store from '../store';
import moment from 'moment';
import AvatarPlaceholder from '../assets/auth/register/avatar-placeholder.png'
import { isTutorProfile, ProfileRole } from '../store/profile/profileSlice';

export const successToast = (message) => {
	toast.success(message, {
		style: {
			background: '#333',
			color: '#fff',
		},
	});
};

export const errorToast = (message) => {
	toast.error(message, {
		style: {
			background: '#333',
			color: '#fff',
		},
	});
};

function buildPublicAssetUrl(pStr) {
	if (pStr.startsWith('http://') || pStr.startsWith('https://')) return pStr;
	const base = (
		process.env.REACT_APP_BACKEND_URL ||
		process.env.REACT_APP_BACKEND_DOMAIN ||
		''
	).replace(/\/+$/, '');
	const pathPart = pStr.startsWith('/') ? pStr : `/${pStr}`;
	return `${base}${pathPart}`;
}

export const getUploadedFileUrl = (path) => {
	if (path == null || path === '') return '';
	let pStr = String(path).replace(/\\/g, '/');
	if (pStr.startsWith('http://') || pStr.startsWith('https://')) return pStr;
	if (!pStr.startsWith('/files/')) {
		const idx = pStr.toLowerCase().indexOf('/files/');
		if (idx >= 0) pStr = pStr.slice(idx);
	}
	if (!pStr.startsWith('/files/')) {
		return buildPublicAssetUrl(pStr);
	}
	const baseRaw = (
		process.env.REACT_APP_BACKEND_DOMAIN ||
		process.env.REACT_APP_BACKEND_URL ||
		''
	).replace(/\/+$/, '');
	let base = baseRaw;
	if (base && !/\/api(\/|$)/i.test(base)) {
		base = `${base}/api/v1`;
	}
	const pathPart = pStr.startsWith('/') ? pStr : `/${pStr}`;
	return `${base}${pathPart}`;
};

export const getImage = (path, type = "") => {
	if (!path && type == "AVATAR"){
		return AvatarPlaceholder
	}
	if (path == null || path === '') return '';
	let pStr = String(path).replace(/\\/g, '/');
	if (pStr.startsWith('http://') || pStr.startsWith('https://')) return pStr;
	return buildPublicAssetUrl(pStr);
}

export const resolveMediaUrl = (path) => {
	if (path == null || path === '') return '';
	if (/\/files\//i.test(String(path))) {
		return getUploadedFileUrl(path);
	}
	return getImage(path);
}

export const parseObjByString = (from, ...selectors) =>
	[...selectors].map(s =>
		s
			.replace(/\[([^\[\]]*)\]/g, '.$1.')
			.split('.')
			.filter(t => t !== '')
			.reduce((prev, cur) => prev && prev[cur], from)
	);

export const getYoutubeID = (url) => {
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
	var match = url.match(regExp);
	return (match && match[7].length == 11) ? match[7] : false;
}

// @todo: check wallet module
export const getProfileTutor = () => {
	const profiles = store.getState().profile.profiles;
	return profiles?.find(isTutorProfile) ?? false;
}

// @todo: check wallet module
export const getProfileStudent = () => {
	const profiles = store.getState().profile.profiles;
	return profiles?.find((v) => v.role === ProfileRole.STUDENT) ?? false;
}

export const dateToSlice = (date, withDate = false) => {
	date = moment(date);
	let timeStr = `${date.format("HH:mm")} - ${date.format("HH:50")}`
	return withDate ? moment(date).format("YYYY-MM-DD ") + timeStr: timeStr;
}

export const getMomentDate = (date) => {
	return moment(date);
}


export const getDeviceTimeZone = () => {
	return moment().format("Z")
}

export const NTformatDate = (date) => {
	return moment(date).format("YYYY-MM-DDTHH:00:00Z")
}

export const getLocalDate = (date) => {
	return moment(date).format("YYYY-MM-DD HH:mm");
}

export const isValidEmail = (email) => {
	if (!email || typeof email !== 'string') return false;
	return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
};

export const maskEmail = (email) => {
	const [localPart, domain] = email.split("@");
	if (localPart.length <= 3) {
	  return localPart[0] + "***@" + domain;
	}
	const visible = localPart.slice(0, 3);
	return `${visible}***@${domain}`;
}

export { getDaySliceFieldPaths, validateDaySlices } from './validateBusinessHours';